<template>
  <div
    :class="{'mx-2': !root, 'px-3': !root}"
    class="rounded"
  >
    <div
      v-if="rule.name && isRulesFieldVisible('ruleName')"
      class="pb-2"
    >
      <span
        :class="{
          'diff-change-removed': removed && (changedRule || (ruleDiff.fields && ruleDiff.fields.includes('name'))),
          'diff-change-added': added && (changedRule || (ruleDiff.fields && ruleDiff.fields.includes('name'))),
        }"
      >
        {{ rule.name }}
      </span>
    </div>
    <FormWysiwyg
      v-if="rule.description && isRulesFieldVisible('ruleDescription')"
      :disabled="true"
      class="py-2"
      :class="{
        'diff-change-removed': removed && (changedRule || (ruleDiff.fields && ruleDiff.fields.includes('description'))),
        'diff-change-added': added && (changedRule || (ruleDiff.fields && ruleDiff.fields.includes('description'))),
      }"
      :value="rule.description"
    />
    <strong
      v-if="['anyOf', 'allOf', 'numberOf', 'enrolledIn', 'completed', 'completedAllOf', 'completedAnyOf', 'completedAtLeastXOf', 'completeVariableCoursesAndVariableCredits'].includes(rule.condition)"
    >
      <span
        :class="{
          'diff-change-removed': removed && (changedRule || (ruleDiff.fields && ruleDiff.fields.includes('condition'))),
          'diff-change-added': added && (changedRule || (ruleDiff.fields && ruleDiff.fields.includes('condition'))),
        }"
      >
        {{ displayString }}
      </span>
    </strong>
    <span
      v-else
      :class="{
        'diff-change-removed': removed,
        'diff-change-added': added,
      }"
    >{{ displayString }} </span>

    <!-- Only display sub rules if they exist -->
    <div
      v-if="rule.subRules && rule.subRules.length"
      class="ml-3 mt-1 "
    >
      <div
        v-for="(subRule, index) in rule.subRules"
        :key="index"
      >
        <RequisiteRuleDisplay
          :rule="subRule"
          :isRulesFieldVisible="isRulesFieldVisible"
          class="card card-body"
          :depth="depth+1"
          :titleInterpolation="titleInterpolation"
        />
        <SimpleRequisiteConditionSeparator
          v-if="rule.subRules.length -1 !== index"
          :condition="rule.condition"
        />
      </div>
    </div>
    <div
      v-else-if="shouldShowDataSelect"
      class="mx-2"
    >
      <SimpleRequisiteDataSelectDisplay
        :selection="rule.value"
        :added="added"
        :removed="removed"
        :added-rule-object-ids="ruleDiff.addedRuleObjectIds"
        :removed-rule-object-ids="ruleDiff.removedRuleObjectIds"
        :titleInterpolation="titleInterpolation"
      />
    </div>
    <FormWysiwyg
      v-if="rule.notes && isRulesFieldVisible('ruleNotes')"
      :disabled="true"
      class="py-2"
      :class="{
        'diff-change-removed': removed && (changedRule || (ruleDiff.fields && ruleDiff.fields.includes('notes'))),
        'diff-change-added': added && (changedRule || (ruleDiff.fields && ruleDiff.fields.includes('notes'))),
      }"
      :value="rule.notes"
    />
  </div>
</template>

<script>
import SimpleRequisiteDataSelectDisplay from './SimpleRequisiteDataSelectDisplay'
import SimpleRequisiteConditionSeparator from './SimpleRequisiteConditionSeparator'
import FormWysiwyg from '@/components/Forms/FormWysiwyg'
import { requisiteUtils } from '@coursedog/requisites'
const reqUtil = requisiteUtils()

export default {
  name: 'RequisiteRuleDisplay',
  components: { SimpleRequisiteDataSelectDisplay, SimpleRequisiteConditionSeparator, FormWysiwyg },
  props: {
    rule: {
      type: Object,
      required: true,
    },
    root: {
      type: Boolean,
      default: false,
    },
    depth: {
      type: Number,
      default: 0,
    },
    added: {
      type: Boolean,
      default: false,
    },
    removed: {
      type: Boolean,
      default: false,
    },
    changedRule: {
      type: Boolean,
      default: false,
    },
    ruleDiff: {
      type: Object,
      default: () => ({}),
    },
    isRulesFieldVisible: {
      type: Function,
      default: () => false,
    },
    titleInterpolation: {
      type: String,
      default: '',
    },
  },
  computed: {
    shouldShowDataSelect () {
      return reqUtil.shouldShowDataSelect(this.rule)
    },
    displayString () {
      return reqUtil.simpleRequisiteDisplayString(this.rule)
    },
  },
}
</script>

<style scoped>
  .diff-change-removed {
    background: #fccac7 !important;
    color: #7f231c;
  }

  .diff-change-added {
    background: #cde9ce !important;
    color: #285b2a;
  }
</style>
